import React, { useEffect, useState } from 'react';
import MenuItem from './MenuItem';

import { Typography, Box, Paper, List, ListItem, ListItemText } from '@mui/material';

export default function Menu(props) {

  function handleMenuItemQuantityChange(menuItemObject) {
    props.onMenuItemQuantityChange({menuItemId: menuItemObject.menuItemId, count: menuItemObject.count})
  }

  return (
    props.menu && props.menu.items ? (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h5" gutterBottom>
          {props.menu.name}
        </Typography>
        {
          (props.menu.items.map(menuItem => (
            menuItem.isActive && <MenuItem key={menuItem.id} item={menuItem} onMenuItemQuantityChange={handleMenuItemQuantityChange} />
          )))
        }
    </div>
    ) : (<></>)
  );
}